"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LockWithAsterisk = function LockWithAsterisk(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "lock-with-asterisk",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M3.25 2c.1 0 .2.01.28.03v.02l-.02.1-.01.1c0 .35.2.66.52.8l.1.03.13.03-.07.1-.06.11a.85.85 0 00.26 1l.1.06.06.04.04.02c.14.05.28.07.42.05V6a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V3.75c0-.14.11-.25.25-.25H2v-.25C2 2.56 2.56 2 3.25 2zm.88 2.25H2.38a.13.13 0 00-.13.13v1.25c0 .06.06.12.13.12h1.75c.06 0 .12-.06.12-.13V4.38a.13.13 0 00-.13-.12zm-.88.5a.25.25 0 110 .5.25.25 0 010-.5zM5.5 1a.34.34 0 01.34.38l-.11.9.8-.34a.34.34 0 01.46.23.35.35 0 01-.3.44l-.84.12.52.71a.35.35 0 01-.1.51.34.34 0 01-.48-.16l-.29-.7-.29.7a.34.34 0 01-.48.16.35.35 0 01-.1-.5l.52-.72-.85-.12a.35.35 0 01-.3-.4l.01-.04a.34.34 0 01.47-.23l.79.33-.1-.89A.34.34 0 015.5 1zM3.25 2.75a.5.5 0 00-.5.41V3.5h1v-.25a.5.5 0 00-.41-.5h-.09z"
  }));
};

LockWithAsterisk.defaultProps = {
  size: 8,
  color: '#444'
};
var _default = LockWithAsterisk;
exports["default"] = _default;